// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2194":"6d05e529","3681":"f0b01e7f","8901":"4052c75f","9015":"ff78de08"}[chunkId] + ".css";
};